export const COLUMNS_ENUM = Object.freeze({
  DATA_SERVICE: { name: "Data Service", order: 0 },
  CONFIGURATION: { name: "Configuration", order: 1 },
  FILTER_ON_AS: { name: "Filter on AS", order: 2 },
  DISPLAYED: { name: "Displayed", order: 3 },
  ENABLED: { name: "Enabled", order: 4 },
});

export const TOTAL_NUMBER_OF_DATA_SERVICES = 4;
